import "./ThinksToDo.scss";
import { LikeIcon, MyPerformanceEvaluationIcon } from "../../assets/images";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import { LoginResponseType } from "../../redux/auth/authTypes";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import { useEffect, useState } from "react";

type AppProps = {
  performanceEvaluationList: any[] | [];
  handleFeedBackModal: (data?: string) => void;
  history: any;
  loginData: LoginResponseType;
  thinksToDoFetching: boolean;
  isPerformanceEvaluationListPresent: boolean;
};
const ManagerPEform = ({
  performanceEvaluationList,
  handleFeedBackModal,
  history,
  loginData,
  thinksToDoFetching,
  isPerformanceEvaluationListPresent,
}: AppProps) => {
  const [noFeedbackList, setNoFeedBackList] = useState<any>();
  useEffect(() => {
    setNoFeedBackList(
      performanceEvaluationList?.filter(
        (el) => !el?.feedback || el?.feedback?.length === 0
      )
    );
  }, [performanceEvaluationList]);

  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={MyPerformanceEvaluationIcon} alt="user icon" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  Manager PE Forms{" "}
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  PE Review Requests
                </p>
              </div>
            </div>
            {isPerformanceEvaluationListPresent && (
              <div className="d-flex align-items-center p-4">
                <span
                  className="mr-3"
                  style={{
                    textDecoration: "underline",
                    color: "#dd4433",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    history.push({
                      pathname: `/my-space/performance-evaluation-list`,
                      state: { activeTab: "allPE" },
                    });
                  }}
                >
                  View All
                </span>
              </div>
            )}
          </div>
          <hr className="m-0"></hr>
          {noFeedbackList?.length > 0 ? (
            noFeedbackList?.map((el: any) => {
              return (
                <div>
                  <div
                    className="d-flex align-items-center p-3"
                    style={{ gap: "3%" }}
                  >
                    <div>
                      <CustomizedAvatar
                        name={`${el?.created_by?.first_name} ${
                          el?.created_by?.last_name
                            ? el?.created_by?.last_name
                            : ""
                        }`}
                        image={el?.created_by?.profile_pic?.file_url}
                        style={{ width: "58px", fontSize: "21px" }}
                      />
                    </div>
                    <div>
                      <div>
                        <p
                          className="mt-0 mb-1"
                          style={{
                            color: "#262a44",
                            fontSize: "16px",
                            fontWeight: 500,
                            marginBottom: "-2px",
                          }}
                        >
                          {`${el?.created_by?.first_name} ${
                            el?.created_by?.last_name
                              ? el?.created_by?.last_name
                              : ""
                          } has submitted "${el?.title}"`}
                        </p>
                        <p
                          style={{
                            margin: "0px",
                            fontSize: "14px",
                            color: "#6e7491",
                          }}
                        >
                          {`${
                            el?.created_by?.job_title
                              ? el?.created_by?.job_title
                              : ""
                          } ${
                            el?.created_by?.job_title &&
                            el?.created_by?.department
                              ? "|"
                              : ""
                          } ${
                            el?.created_by?.department
                              ? el?.created_by?.department
                              : ""
                          }`}
                        </p>
                      </div>
                      <div
                        style={{
                          color: "#6e7491",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "#6e7491",
                          }}
                        >
                          {`${el?.start_date} to ${el?.end_date}`}
                        </span>
                      </div>
                      <button
                        className="btn btn-primary mt-2"
                        onClick={() => handleFeedBackModal(el?._id)}
                      >
                        Submit Feedback
                      </button>
                    </div>
                  </div>
                  <hr></hr>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70%",
                flexDirection: "column",
              }}
            >
              <img src={LikeIcon} alt="like-icon" />
              <div
                className="mt-3"
                style={{
                  fontSize: "19px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                No PE Form is there!
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ManagerPEform;
